module.exports = __webpack_public_path__ + "img/icon_a.0e5a6bc1.png";